import { Pdf } from '@fluentsms/agentnet-web-icons';
import { SvgIconProps, useTheme } from '@material-ui/core';
import React from 'react';

export const PdfDoc = (props: SvgIconProps): JSX.Element => {
  const theme = useTheme();

  return <Pdf height="auto" width="16" fill={theme.palette?.document?.pdf} {...props} />;
};
